"use client";

import { useEffect, useState } from "react";
import ApprovedDriverAvailability from "./ApprovedDriverAvailability";

type Props = {
  loggedIn: boolean;
  compact?: boolean;
};

type Registration = {
  status: string;
  category: string;
};

export default function HomepageDriverTileAvailability({ loggedIn, compact = false }: Props) {
  const [registration, setRegistration] = useState<Registration | null>(null);
  const [loading, setLoading] = useState(loggedIn);

  useEffect(() => {
    if (!loggedIn) {
      return;
    }

    const controller = new AbortController();

    async function loadRegistration() {
      setLoading(true);
      setRegistration(null);

      try {
        const response = await fetch("/api/driver-registration", {
          cache: "no-store",
          credentials: "same-origin",
          signal: controller.signal,
        });

        if (!response.ok) return;

        const data = await response.json();

        if (!controller.signal.aborted) {
          setRegistration(data.registration ?? null);
        }
      } catch {
        // Fail closed: never show availability without verified approval.
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }

    void loadRegistration();

    return () => controller.abort();
  }, [loggedIn]);

  if (!loggedIn || loading) return null;

  if (
    registration?.status !== "Approved" ||
    !["Passenger", "Goods"].includes(registration.category)
  ) {
    return null;
  }

  return (
    <div className={compact ? "w-full" : "w-full rounded-xl border border-emerald-200 bg-white p-3"}>
      <ApprovedDriverAvailability category={registration.category} compact={compact} />
    </div>
  );
}
